import React, {
  useState,
  forwardRef,
  useRef,
  useImperativeHandle,
  lazy,
  Suspense,
} from 'react'
import { useTranslation } from 'i18n'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import PlaceholderImage from 'components/PlaceholderImage'
import IntersectionVisible from 'components/IntersectionVisible'

import { getPersonalityData } from 'services/break.js'

import analytics from 'global/AnalyticsData'

import DropdownArrow from 'images/inline/dropdown-arrow.svg'

import './FilteringStep.scss'

const toClassSlug = str =>
  str
    ?.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || ''

const SliderComponent = forwardRef((props, ref) => {
  var sliderRef = {}
  var settings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 500,
    variableWidth: true,
    dotsClass: 'slick-dots card__slider-dots',
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          swipeToSlide: true,
          infinite: true,
        },
      },
    ],
  }
  useImperativeHandle(ref, () => ({
    GotoSlick() {
      sliderRef.slickGoTo(0)
    },
  }))
  return (
    <Slider
      className={props.className}
      ref={slider => (sliderRef = slider)}
      {...settings}
    >
      {props.children.map((obj, index) => {
        return <React.Fragment key={index}>{obj}</React.Fragment>
      })}
    </Slider>
  )
})

const FilteringStep = ({
  brk,
  breakId,
  step,
  onEngage = function () {},
  onAwardPoints = function () {},
  userType,
  service,
  nextStepButton,
  skipButton,
}) => {
  const FilteringModal = lazy(() => import('./FilteringModal'))

  const { t } = useTranslation(['filtering', 'common'])

  const [interacted, setInteracted] = useState(false)
  const [results, setFilterResult] = useState(step.filtering.results)
  const [isModalOpen, setModalState] = useState(false)
  const [selectedTile, setSelectedTile] = useState({})
  const [dropdownNum, setDropDown] = useState(null)
  const [pqResultId, setPqResultId] = useState(undefined)
  const savedResults = step.filtering.results
  const [activeFilters, setActiveFilters] = useState([])
  const [activeFilterValues, setActiveFilterValues] = useState([])
  const [activeSelect, setActiveSelect] = useState([])
  const childRef = useRef()

  const handleIsOnScreen = async isIntersecting => {
    if (isIntersecting) {
      try {
        const pqResultId = await getPersonalityData(breakId)
        setPqResultId(pqResultId)
      } catch (e) {
        console.log(e)
      }
    }
  }

  const handleSelect = (id, label, value, dropdown, text, skipAnalytics) => {
    pqResultId && setPqResultId(null)
    //TODO - refactor this
    //activeFilters is always 0 - because its an object, not an array
    if (activeFilters.length >= 1) {
      activeFilters[label] = []
      let postFilterResultSet = results.filter(result =>
        result.associatedItems.includes(value),
      )
      activeSelect[label].push(text)
      activeFilters[label].push(postFilterResultSet)
      // activeFilterValues = [value]
      setActiveFilters(activeFilters)
      // setActiveFilterValues(activeFilterValues)
      setActiveSelect(activeSelect)
      setFilterResult(postFilterResultSet) //clear filters before sort??
    } else {
      if (activeFilters[label]) {
        if (activeSelect[label][0] === text) {
          //deselect
          let updatedFilterValues = activeFilterValues
          updatedFilterValues[label] = []
          let newResults = savedResults
          Object.values(updatedFilterValues).forEach(arr => {
            if (arr.length > 0) {
              newResults = newResults.filter(result =>
                result.associatedItems.includes(arr[0]),
              )
            }
          })
          delete activeSelect[label]
          setActiveFilterValues(updatedFilterValues)
          setActiveFilters(activeSelect)
          setFilterResult(newResults)
        } else {
          //sorting an existing filter
          setActiveSelect([])
          setActiveFilters([])
          setFilterResult(savedResults) //clear filters before sort??
          activeFilters[label] = []
          activeSelect[label] = []
          let postFilterResultSet = savedResults.filter(result =>
            result.associatedItems.includes(value),
          )
          activeSelect[label].push(text)
          activeFilters[label].push(postFilterResultSet)

          //*** */
          let updatedFilterValues = activeFilterValues
          updatedFilterValues[label] = [value]
          setActiveFilterValues(updatedFilterValues)

          setActiveFilters(activeFilters)
          setActiveSelect(activeSelect)
          setFilterResult(postFilterResultSet) //clear filters before sort??
        }
      } else {
        //add index
        activeFilters[label] = []
        activeSelect[label] = []
        let postFilterResultSet = results.filter(result =>
          result.associatedItems.includes(value),
        )
        activeSelect[label].push(text)
        activeFilters[label].push(postFilterResultSet)

        //*** */
        let updatedFilterValues = activeFilterValues
        updatedFilterValues[label] = [value]
        setActiveFilterValues(updatedFilterValues)

        setActiveSelect(activeSelect)
        setActiveFilters(activeFilters)
        setFilterResult(postFilterResultSet) //clear filters before sort??
      }
    }
    setTimeout(() => {
      setDropDown(null)
      // @ts-ignore
      if (window) {
        //ie11 doesnt understand resize events so stackoverflow copypasta it is
        if (
          navigator.userAgent.indexOf('MSIE') !== -1 ||
          navigator.appVersion.indexOf('Trident/') > 0
        ) {
          var evt = document.createEvent('UIEvents')
          evt.initUIEvent('resize', true, false, window, 0)
          window.dispatchEvent(evt)
        } else {
          window.dispatchEvent(new Event('resize'))
        }
      }
      // window && window.dispatchEvent(new Event('resize'));
      childRef.current.GotoSlick(0)
    }, 200)

    if (!skipAnalytics) {
      analytics.stepEvent(
        'step_interaction_filter_select_option_clicked',
        step,
        {
          context_id: dropdown.id,
          context: dropdown.label,
          result_id: value,
          result: text,
        },
      )
    }
    // const filterResult = results.filter(result =>
    //     result.associatedItems.includes(value) )
    //     setFilterResult(filterResult)
  }
  const handleOpenTile = object => {
    setModalState(true)
    setSelectedTile(object)
    onEngage()
    onAwardPoints()

    analytics.stepEvent('step_interaction_filter_results_clicked', step, {
      result_id: object.id,
      result: object.title,
    })
  }

  const handleDropDown = (index, tag, dropdown) => {
    if (tag === 'select') {
      onEngage()
      onAwardPoints()

      if (dropdownNum === index) {
        setDropDown(null)
      } else {
        setDropDown(index)

        analytics.stepEvent('step_interaction_filter_select', step, {
          result_id: dropdown.id,
          result: dropdown.label,
        })
      }
    } else {
      if (dropdownNum !== null) {
        setDropDown(null)
      }
    }
  }

  const MobileFilter = (filtering, pqResultId) => {
    return (
      <>
        <div className="filtering__steps">
          {!!filtering.dropdowns.length &&
            filtering.dropdowns.map((dropdown, index) => {
              return (
                <select
                  className={`filtering__options mobile`}
                  onClick={e => {
                    e.stopPropagation()
                    e.preventDefault()
                    handleDropDown(index, 'select', dropdown)
                  }}
                  onChange={e => {
                    // console.log(e.target.value)
                    // console.log(e.target[e.target.selectedIndex].id)
                    const itemText = e.target.value
                    const itemId = e.target[e.target.selectedIndex].id
                    if (itemText === '') {
                      setActiveFilterValues([])
                      setActiveFilters([])
                      setActiveSelect([])
                      setFilterResult(savedResults)
                      pqResultId && setPqResultId(null)
                    } else {
                      handleSelect(
                        dropdown.id,
                        dropdown.label,
                        itemId,
                        dropdown,
                        itemText,
                      )
                    }

                    if (e.target.value === 'clear') {
                      setActiveFilterValues([])
                      setActiveFilters([])
                      setActiveSelect([])
                      setFilterResult(savedResults)
                      pqResultId && setPqResultId(null)
                    }
                  }}
                >
                  <option value="">
                    {/* {activeSelect[dropdown.label]
                        ? activeSelect[dropdown.label][0]
                          ? activeSelect[dropdown.label][0]
                          : dropdown.label
                        : dropdown.label} */}
                    {dropdown.label}
                  </option>
                  {dropdown.items &&
                    dropdown.items.map((item, optionindex) => {
                      //dynamic default filter based on pqresultid
                      const selectThis =
                        item.dynamics &&
                        item.dynamics.some(
                          dynamic => dynamic.value === pqResultId,
                        )
                      selectThis &&
                        handleSelect(
                          dropdown.id,
                          dropdown.label,
                          item.id,
                          dropdown,
                          item.text,
                        )

                      return (
                        <option
                          key={optionindex}
                          value={item.text}
                          id={item.id}
                          checked={
                            selectThis
                              ? true
                              : activeSelect[dropdown.label]
                              ? activeSelect[dropdown.label][0] === item.text
                                ? true
                                : false
                              : false
                          }
                        >
                          {item.text}
                        </option>
                      )
                    })}
                  <option value="clear" key="clear">
                    {t('filtering:clearFilters')}
                  </option>
                </select>
              )
            })}
        </div>
      </>
    )
  }
  const DesktopFilter = (filtering, pqResultId) => {
    return (
      <>
        <div className="filtering__steps">
          {!!filtering.dropdowns.length &&
            filtering.dropdowns.map((dropdown, index) => {
              return (
                <div className={`filtering__step`} key={index}>
                  <a
                    title={
                      activeSelect[dropdown.label]
                        ? activeSelect[dropdown.label][0]
                          ? activeSelect[dropdown.label][0]
                          : dropdown.label
                        : dropdown.label
                    }
                    className={`filtering__step-name ${
                      index === dropdownNum ? 'active' : ''
                    }`}
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      handleDropDown(index, 'select', dropdown)
                    }}
                  >
                    <span>
                      {activeSelect[dropdown.label]
                        ? activeSelect[dropdown.label][0]
                          ? activeSelect[dropdown.label][0]
                          : dropdown.label
                        : dropdown.label}
                    </span>
                    <DropdownArrow className="arrow" />
                  </a>
                  <ul
                    className={`filtering__options`}
                    style={{
                      display: `${
                        index === dropdownNum ? 'inline-block' : 'none'
                      }`,
                    }}
                  >
                    {dropdown.items &&
                      dropdown.items.map((item, optionindex) => {
                        //dynamic default filter based on pqresultid
                        const selectThis =
                          item.dynamics &&
                          item.dynamics.some(
                            dynamic => dynamic.value === pqResultId,
                          )
                        selectThis &&
                          !(
                            activeFilters[dropdown.label] &&
                            activeSelect[dropdown.label][0] === item.text
                          ) &&
                          handleSelect(
                            dropdown.id,
                            dropdown.label,
                            item.id,
                            dropdown,
                            item.text,
                            true,
                          )
                        return (
                          <li key={optionindex}>
                            <label className="custom-btn-label">
                              <input
                                type="checkbox"
                                value="content 1"
                                name={item.text}
                                onChange={e => {
                                  handleSelect(
                                    dropdown.id,
                                    dropdown.label,
                                    item.id,
                                    dropdown,
                                    item.text,
                                  )
                                }}
                                checked={
                                  selectThis
                                    ? true
                                    : activeSelect[dropdown.label]
                                    ? activeSelect[dropdown.label][0] ===
                                      item.text
                                      ? true
                                      : false
                                    : false
                                }
                              />
                              <span className="filter-name">{item.text}</span>
                            </label>
                          </li>
                        )
                      })}
                    <li key="clear">
                      <span
                        className="clear"
                        onClick={() => {
                          setActiveFilterValues([])
                          setActiveFilters([])
                          setActiveSelect([])
                          setFilterResult(savedResults)
                          pqResultId && setPqResultId(null)
                          //BR-236 hack to allow slick to apply correct width for slider carousel
                          const slickList = document.querySelector(
                            `div[data-stepid='${step.id}'] .card__slider .slick-slider`,
                          )
                          slickList.style.visibility = 'hidden'
                          setTimeout(() => {
                            slickList.style.visibility = 'visible'
                            setDropDown(null)
                            // @ts-ignore
                            if (window) {
                              //ie11 doesnt understand resize events so stackoverflow copypasta it is
                              if (
                                navigator.userAgent.indexOf('MSIE') !== -1 ||
                                navigator.appVersion.indexOf('Trident/') > 0
                              ) {
                                var evt = document.createEvent('UIEvents')
                                evt.initUIEvent(
                                  'resize',
                                  true,
                                  false,
                                  window,
                                  0,
                                )
                                window.dispatchEvent(evt)
                              } else {
                                window.dispatchEvent(new Event('resize'))
                              }
                            }
                            // window && window.dispatchEvent(new Event('resize'));
                            childRef.current.GotoSlick(0)
                          }, 200)
                        }}
                      >
                        {t('filtering:clearFilters')}
                      </span>
                    </li>
                  </ul>
                </div>
              )
            })}
        </div>
      </>
    )
  }

  return (
    <>
      <section className={`filtering`}>
        <div
          className={`step-content ${
            brk?.navigationType === 'TOP' ? 'top-navigation' : ''
          } ${step.backgroundImage ? ' with-shadow' : ''}`}
        >
          <IntersectionVisible
            active={true}
            options={{
              threshold: 0.4,
            }}
            onIntersect={handleIsOnScreen}
          >
            <div className="filtering__content">
              <h2
                className={`step-content__title`}
                dangerouslySetInnerHTML={{ __html: step.filtering.headline }}
              />
              <p
                dangerouslySetInnerHTML={{ __html: step.filtering.introCopy }}
              />
            </div>
            {DesktopFilter(step.filtering, pqResultId)}
            {/* {innerWidth < 767 ? MobileFilter(step.filtering, pqResultId) : DesktopFilter(step.filtering, pqResultId)} */}
            {/* {isMobile ? MobileFilter(step.filtering, pqResultId) : DesktopFilter(step.filtering, pqResultId)} */}
            <div className="card__slider">
              <SliderComponent className="card__slider" ref={childRef}>
                {results &&
                  results.map((obj, index) => {
                    return (
                      <a
                        key={index}
                        onClick={e => {
                          e.preventDefault()
                          handleOpenTile(obj)
                          !interacted && setInteracted(true)
                        }}
                        title={obj.title}
                        className="card__slide"
                      >
                        <figure className="card__slide-img">
                          <PlaceholderImage
                            src={
                              obj.image
                                ? `${process.env.SITE_ASSET_URL}/${obj.image.id}`
                                : ''
                            }
                            height={400}
                            width={600}
                            alt={obj.image?.altAttribute || ''}
                            className={[
                              'filtering-result-image',
                              `filtering-result-image--pos-${index}`,
                              obj.title &&
                                `filtering-result-image--title-${toClassSlug(obj.title)}`,
                            ]
                              .filter(Boolean)
                              .join(' ')}
                          />
                        </figure>
                        <div className="card__slide-content">
                          <div className="card-slide-title" dangerouslySetInnerHTML={{ __html: obj.title }} />
                        </div>
                      </a>
                    )
                  })}
              </SliderComponent>
            </div>
          </IntersectionVisible>
          {skipButton}
          {nextStepButton}
        </div>
      </section>

      {isModalOpen && (
        <Suspense fallback={<div>{t('common:loading')}</div>}>
          <FilteringModal
            isModalOpen={isModalOpen}
            setModalState={setModalState}
            selectedTile={selectedTile}
            step={step}
          />
        </Suspense>
      )}
    </>
  )
}

export default FilteringStep
